(function () {
  'use strict';

  var PHONE_D = '+92 319 1303778';
  var PHONE_R = '+923191303778';
  var EMAIL   = 'outphicstore@gmail.com';

  var I = {
    cod: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>',
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="1.8"/><circle cx="17.5" cy="18.5" r="1.8"/></svg>',
    ex: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h13l-3-3M21 16H8l3 3"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.2-1.7-.9-2-1-.3-.1-.5-.1-.6.1l-.9 1c-.2.2-.3.2-.6.1-1.6-.8-2.7-1.8-3.4-3.1-.2-.4 0-.5.2-.7l.5-.6c.1-.2.1-.3 0-.5l-.9-2c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.4-.8.8-1 1.9-.6 3 .6 1.9 2.6 4.4 5.4 5.5 1.6.6 2.6.6 3.4.4.6-.2 1.4-.8 1.6-1.5.1-.4.1-.7 0-.8l-.3.1zM12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2z"/></svg>'
  };

  function badge(ico, t, s) {
    return '<div class="op-badge"><span class="op-badge__ico">' + ico + '</span>' +
      '<span><span class="op-badge__t">' + t + '</span>' +
      '<span class="op-badge__s">' + s + '</span></span></div>';
  }

  function build() {
    if (document.querySelector('.op-footer-extra')) return;
    var foot = document.getElementById('t4s-footer');
    if (!foot) return;

    var wrap = document.createElement('div');
    wrap.className = 'op-footer-extra';

    var trust = document.createElement('div');
    trust.className = 'op-trust';
    trust.innerHTML = '<div class="op-trust__grid">' +
      badge(I.cod, 'Cash on Delivery', 'Pay when your order arrives') +
      badge(I.ship, 'Flat Rs. 250 Delivery', 'Anywhere in Pakistan') +
      badge(I.ex, '7-Day Exchange', 'Wrong size? Swap it easily') +
    '</div>';

    var c = document.createElement('div');
    c.className = 'op-contact';
    c.innerHTML = '<div class="op-contact__grid">' +
      '<div>' +
        '<h3 class="op-contact__h">Call or WhatsApp</h3>' +
        '<p class="op-contact__l">' +
          '<a class="op-contact__big" href="tel:' + PHONE_R + '">' + PHONE_D + '</a><br>' +
          '<a class="op-wa" href="https://wa.me/' + PHONE_R.replace('+', '') + '" target="_blank" rel="noopener">' + I.wa + 'Chat on WhatsApp</a>' +
        '</p>' +
      '</div>' +
      '<div>' +
        '<h3 class="op-contact__h">Office Address</h3>' +
        '<p class="op-contact__l">Outphic<br>North Karachi<br>Karachi, Sindh<br>Pakistan</p>' +
      '</div>' +
      '<div>' +
        '<h3 class="op-contact__h">Business Hours</h3>' +
        '<p class="op-contact__l">Monday \u2013 Saturday<br>11:00 AM \u2013 8:00 PM (PKT)<br>Sunday: Closed</p>' +
      '</div>' +
      '<div>' +
        '<h3 class="op-contact__h">Email</h3>' +
        '<p class="op-contact__l"><a href="mailto:' + EMAIL + '">' + EMAIL + '</a><br>' +
        'We reply within 24 hours.</p>' +
      '</div>' +
    '</div>';

    wrap.appendChild(trust);
    wrap.appendChild(c);

    /* Put it inside the dark bottom bar at the very end of the page. */
    var bar = foot.querySelector('[id*="bottom-bar" i], .t4s-bottom-bar, .t4s-footer__bottom, .t4s-copyright');
    var barSection = bar && bar.closest ? (bar.closest('.shopify-section') || bar) : null;

    if (barSection && barSection.firstChild) {
      barSection.insertBefore(wrap, barSection.firstChild);
    } else {
      foot.appendChild(wrap);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else { build(); }
  window.addEventListener('pageshow', build);
})();
